import { DashboardMessage } from 'bd-web-components';
import { ReactNode } from 'react';
import Loader from '../Loader';

type ConditionalRenderComponentProps = {
  isLoading?: boolean;
  isMessage?: boolean;
  isRender?: boolean;
  isError?: boolean;
  hasImage?: boolean;
  maxHeight?: undefined | number
  children?: ReactNode;
  maintext?: string;
  subtext?: string;
};

function ConditionalRenderComponent({
  isLoading = false,
  isMessage = false,
  isRender = false,
  isError = false,
  hasImage = true,
  maxHeight = undefined,
  maintext = 'Desculpa, não existem dados...',
  subtext = 'Ainda não possuímos dados suficientes para apresentar um gráfico.',
  children,
}: ConditionalRenderComponentProps) {
  const nMainText = isError ? 'Um erro aconteceu...' : maintext
  const nSubText = isError ? 'Já estamos trabalhando para corrigir o problema' : subtext
  return (
    <>
      {
        isLoading && (
          <Loader />
        )}
      {
        isMessage && (
          <DashboardMessage
            isError={isError}
            isImage={hasImage}
            maxHeight={maxHeight}
            maintext={nMainText}
            subtext={nSubText} 
            />
            )}
      {
        isError && (
          <DashboardMessage 
            isError={isError} 
            isImage={hasImage}
            maxHeight={maxHeight} 
            maintext={nMainText}
            subtext={nSubText}
          />
        )}
      {
        (isRender && children) &&
          <>
            {children}
          </>
        }
    </>
  );
}

export default ConditionalRenderComponent;